import { useCopyToClipboard } from '#app/hooks/useCopyToClipboard.js';
import { getUrl } from '@contra/routes';
import { useCallback } from 'react';

const routeKeyFromVariant = {
  default: '/@username',
  projects: '/@username/projects',
  services: '/@username/services',
} as const;

export const useCopyProfileUrl = ({
  successToast = `Successfully copied profile link to clipboard!`,
  userProfile,
  utmTag,
  variant = 'default',
}: {
  successToast?: string;
  userProfile: {
    displayUsername: string;
  };
  utmTag?: {
    utm_campaign: string;
    utm_medium: string;
    utm_source: string;
  };
  variant?: 'default' | 'projects' | 'services';
}) => {
  const routeParameters = {
    args: {
      username: userProfile.displayUsername,
    },
    search: utmTag
      ? {
          utm_campaign: utmTag.utm_campaign,
          utm_medium: utmTag.utm_medium,
          utm_source: utmTag.utm_source,
        }
      : undefined,
  };

  const routeKey = routeKeyFromVariant[variant];
  const profileUrl = getUrl(routeKey, routeParameters);

  const copyUrl = useCopyToClipboard();

  const onCopyProfileLink = useCallback(
    async () =>
      await copyUrl(profileUrl, {
        successToast,
      }),
    [copyUrl, profileUrl],
  );

  return {
    onCopyProfileLink,
  };
};
